import { RefObject, useCallback, useEffect } from "react";

type Props = {
  elementRef: RefObject<Element>;
  onUpdate: () => void;
  onLastIntersectedItem: (isIntersecting: boolean) => void;
  params?: IntersectionObserverInit;
};

export const useIntersectionObserver = ({
  elementRef,
  onUpdate,
  params = {},
  onLastIntersectedItem,
}: Props) => {
  const handleUpdate = useCallback(
    ([entry]: IntersectionObserverEntry[]): void => {
      if (entry.isIntersecting) {
        onUpdate();
      }

      onLastIntersectedItem(entry.isIntersecting);
    },
    [onUpdate, onLastIntersectedItem]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(handleUpdate, {
      threshold: 0.1,
    });

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    // Clean up the observer
    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [elementRef, handleUpdate, params]);
};
